import { addToCart, updateCartItemQuantity } from "./cart";
import { decideFreeGiftAction, findFreeGiftLine, FREE_GIFT_VARIANT_ID, type FreeGiftCustomer } from "./free-gift-promo";

declare global {
  interface Window {
    FREE_GIFT_CUSTOMER?: FreeGiftCustomer;
  }
}

let isSyncing = false;
let needsResync = false;

async function syncFreeGiftLine() {
  if (isSyncing) {
    needsResync = true;
    return;
  }
  isSyncing = true;

  try {
    const cart = window.Alpine.store("cart");
    const action = decideFreeGiftAction({
      subtotalCents: cart.items_subtotal_price,
      customer: window.FREE_GIFT_CUSTOMER ?? null,
      cart,
      marketHandle: window.localization?.market?.handle,
    });

    if (action === "add") {
      await addToCart({ items: [{ id: String(FREE_GIFT_VARIANT_ID), quantity: 1 }] });
    } else if (action === "remove") {
      const line = findFreeGiftLine(cart);
      if (line?.key) {
        // `item` (not just `id`) is required so cart.ts can retry by variant if this key has gone stale.
        await updateCartItemQuantity({ id: line.key, quantity: 0, item: line as any });
      }
    }
  } catch (error) {
    console.error("Failed to sync Free Gift Promo line", error);
  } finally {
    isSyncing = false;
    if (needsResync) {
      needsResync = false;
      void syncFreeGiftLine();
    }
  }
}

export function initFreeGiftPromoWatcher() {
  window.addEventListener("cranky:cart:update", () => void syncFreeGiftLine());
  document.addEventListener("alpine:init", () => void syncFreeGiftLine());
}
